import { TMigrationTransform } from './models/TMigrationTransform';
import { MigrationTransformBase } from './MigrationTransformBase';
import { MoveTransform } from './MoveTransform';
import { TMigrationDirection } from '../models/TMigrationDirection';
import { AddTransform } from './AddTransform';
import { DeleteTransform } from './DeleteTransform';
import { ValueTransform } from './ValueTransform';

export class MigrationTransform {
	constructor(public transform: TMigrationTransform) { }
	execute(seed: object, direction: TMigrationDirection): object {

		let transformInstance: MigrationTransformBase | undefined;
		switch (this.transform.type) {
			case 'add':
				transformInstance = new AddTransform(this.transform.options);
				break;
			case 'delete':
				transformInstance = new DeleteTransform(this.transform.options);
				break;
			case 'move':
				transformInstance = new MoveTransform(this.transform.options);
				break;
			case 'value':
				transformInstance = new ValueTransform(this.transform.options);
				break;
		}
		let result: object = seed;
		if (transformInstance) {
			result = transformInstance[direction](seed);
		}
		return result;
	}
}